import React, { useEffect, useState } from 'react';
import { useParams, Outlet, useNavigate } from 'react-router-dom';
import { getGeminiKey } from './api';
import Loader from './components/Loader';
import ProjectHeader from './components/ProjectHeader';
import useProject from './hooks/useProject';

export default function ProjectDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { project, loading, error, refreshProject } = useProject(slug);
  const [geminiConfigured, setGeminiConfigured] = useState(false);
  const [seoAnalyseButton, setSeoAnalyseButton] = useState(null);
  const [positionAnalyseButton, setPositionAnalyseButton] = useState(null);

  useEffect(() => {
    getGeminiKey()
      .then((data) => setGeminiConfigured(!!data.is_configured))
      .catch(() => setGeminiConfigured(false));
  }, [slug]);

  const handleAudit = () => {
    navigate(`/projects/${slug}/audit`);
  };

  if (loading) {
    return <Loader className="h-96" label="Chargement du projet..." />;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center h-96 text-error">{error}</div>;
  }
  if (!project) return null;

  return (
    <div className="w-full max-w-full mx-auto px-2 md:px-0 flex flex-col gap-6">
      <ProjectHeader
        project={project}
        onBack={() => (window.location.href = '/projects')}
        onAudit={handleAudit}
        auditLoading={false}
        extraButton={seoAnalyseButton}
        positionAnalyseButton={positionAnalyseButton}
      />
      <Outlet
        context={{
          project,
          refreshProject,
          handleAudit,
          geminiConfigured,
          setSeoAnalyseButton,
          setPositionAnalyseButton,
        }}
      />
    </div>
  );
}
